import { createFileRoute } from '@tanstack/react-router';
import { OverviewPage } from '@/features/organization/overview/overview-page';

export const Route = createFileRoute('/_app/o/$organizationId/settings/')({
    staticData: { crumbs: [{ label: 'settings.nav.overview' }] },
    component: function OverviewRoute() {
        const { organizationId } = Route.useParams();
        return <OverviewPage organizationId={organizationId} />;
    },
});
